const name = 'BaseScroll';
const properties = {};
function animate(kit, elements, duration = 0, delay = 0, { x = 0, y = 0, autoKill = false, ...params } = {}) {
    const scrollTo = { x, y, autoKill };
    return kit.engine.tween(elements, { duration, delay, scrollTo, ...params }, [
        'scrollTo',
        'autoKill',
    ]);
}
export { name, properties, animate };
//# sourceMappingURL=baseScroll.js.map